var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12 m-auto" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "d-flex justify-content-start" },
        [
          _c("guest-post-owner-info", {
            attrs: {
              user_data: this.data.owner,
              supplier_data: null,
              shared: false,
              time: this.data.created_at,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-content" }, [
        _c("div", { staticClass: "card-body pt-05 pb-05" }, [
          _c("span", {
            staticClass: "breakAll",
            domProps: { innerHTML: _vm._s(this.data.post_text) },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "img-fluid",
        attrs: {
          src: this.data.media.length > 0 ? this.data.media[0].url : "",
        },
      }),
      _vm._v(" "),
      !this.share
        ? _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between border-top pl-05 pr-05",
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "p-05" }, [
                _c(
                  "span",
                  {
                    attrs: {
                      "data-toggle": "modal",
                      "data-target": "#registerModal",
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-comment-o" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.__("globals.comment")) +
                        "\n                "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "p-05" }, [
                _c("div", { staticClass: "dropdown" }, [
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-toggle",
                      attrs: {
                        id: "socialShareButton",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false",
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-share-alt" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.__("globals.share")) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu",
                      attrs: { "aria-labelledby": "socialShareButton" },
                    },
                    [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(this.social) },
                      }),
                    ]
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "p-05" }, [
      _c("i", {
        staticClass: "fa fa-thumbs-o-up",
        attrs: { "data-toggle": "modal", "data-target": "#registerModal" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }